export default function getResource(label, vars = []) {
    const resources = {
        title: 'This storefront isn’t currently available in your region.',
        subTitle: 'This page is only accessible from within the United States at this time.',
        ctaText: 'Continue Shopping',
        linkText: 'View Sephora International Websites'
    };

    return resources[label];
}
